import { setContext } from '@apollo/client/link/context/index.js';
import { onError } from '@apollo/client/link/error/index.js';
import { ApolloLink } from '@apollo/client/link/core/ApolloLink.js';
import { v4 } from 'uuid';
import { getItem } from './utils/storage.js';
const _pageLoadId = v4();
function getCsrfToken(csrfTokenName) {
    return getItem(csrfTokenName);
}
function getBrowserCookieValue(cookieName) {
    let result = '';
    document.cookie.split(';').forEach(cookie => {
        const pair = cookie.split('=');
        if (pair[0]?.trim() === cookieName) {
            result = pair[1];
        }
    });
    return result;
}
function getEnvironmentFromCookies(envCookieName) {
    return getBrowserCookieValue(envCookieName);
}
export const createAuthLink = (loginUrl = '/_error', csrfTokenName = 'csrfToken', envCookieName = 'environment') => {
    const authLink = setContext((_, { headers }) => {
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                'X-Cvent-CSRF': getCsrfToken(csrfTokenName),
                HttpLogPageLoadId: _pageLoadId,
                HttpLogRequestId: v4(),
                environment: getEnvironmentFromCookies(envCookieName) || '',
                ...{ credentials: 'include' }
            }
        };
    });
    const redirectLink = onError(({ graphQLErrors }) => {
        if (graphQLErrors &&
            graphQLErrors.length > 0 &&
            graphQLErrors[0] &&
            graphQLErrors[0].extensions &&
            graphQLErrors[0].extensions.code === 'UNAUTHENTICATED') {
            if (typeof window !== 'undefined') {
                const redirectUrl = loginUrl;
                const isRelativeUrl = redirectUrl.indexOf('//') === -1;
                // Use relative return url if redirect url is on the same host
                const returnUrl = isRelativeUrl || redirectUrl.split('/')[2]?.split('?')[0] === window.location.host
                    ? window.location.pathname + window.location.search
                    : window.location.href;
                window.location.href = `${redirectUrl}?returnUrl=${encodeURIComponent(returnUrl)}`;
            }
        }
    });
    const links = [authLink, redirectLink];
    return ApolloLink.from(links);
};
//# sourceMappingURL=createAuthLink.js.map